import * as httpTool from '../http-tools'
import * as apiConst from '../api-const'
export default {
    roundFormList (params) {
        return httpTool.fetchPost(apiConst.roundFormListUrl,params)
    },
    memberInfo (params) {
        return httpTool.fetchPost(apiConst.livingMemberTopUrl,params)
    },
    getGroupList (params) {
        return httpTool.fetchPost(apiConst.getGroupListUrl,params)
    },
    roundAllList (params) {
        return httpTool.fetchPost(apiConst.roundAllListUrl,params)
    },
    addRecordFrom (params) {
        return httpTool.fetchPost(apiConst.addRecordFormUrl,params)
    },
    setRoundRecord (params,files) {
        return httpTool.fetchPostFile(apiConst.setRoundRecordUrl,params,files)
    },
    detailOtherForm (params,files) {
        return httpTool.fetchPost(apiConst.detailOtherFormUrl,params)
    },
    setOtherForm (params,files) {
        return httpTool.fetchPostFile(apiConst.setOtherFormUrl,params,files)
    },
    getBreastMilkRecored (params) {
        return httpTool.fetchPost(apiConst.getBreastMilkRecoredUrl,params)
    },
    getColumnList (params) {
        return httpTool.fetchPost(apiConst.columnListUrl,params)
    },
    getCheckInfo (params) {
        return httpTool.fetchPost(apiConst.getCheckInfoUrl,params)
    },
    //喂药委托书添加
    addFeedDrugEntrust (params) {
        return httpTool.fetchPost(apiConst.addFeedDrugEntrustUrl,params)
    },
    //喂药委托书查询list数据
    getFeedDrugEntrustUrlList (params) {
        return httpTool.fetchPost(apiConst.feedDrugEntrustUrl,params)
    },
    //喂药委托书详情数据
    detailFeedDrugEntrustDetail (params) {
        return httpTool.fetchPost(apiConst.detailFeedDrugEntrustDetailUrl,params)
    },
    //喂药委托书数据更新
    updateFeedDrugEntrust (params) {
        return httpTool.fetchPost(apiConst.updateFeedDrugEntrustUrl,params)
    },
    //月子基本护理常识添加
    addConfinementSense (params) {
        return httpTool.fetchPost(apiConst.addConfinementSenseUrl,params)
    },
    //月子基本护理常识数据
    getConfinementSenseListUrlList (params) {
        return httpTool.fetchPost(apiConst.confinementSenseListUrl,params)
    },
    //月子基本护理常识详情数据
    confinementSenseDetail (params) {
        return httpTool.fetchPost(apiConst.confinementSenseDetailUrl,params)
    },
    //月子基本护理常识数据更新
    updateConfinementSense (params) {
        return httpTool.fetchPost(apiConst.updateConfinementSenseUrl,params)
    },
    //获取查房人
    getAgentListFn (params) {
        return httpTool.fetchPost(apiConst.getAgentList,params)
    },
    //获取所用表格列表
    getFormTypeListFn (params) {
        return httpTool.fetchPost(apiConst.getFormTypeList,params)
    },
    //获取查房记录相关表格数据列表
    getFormDataListFn (params) {
        return httpTool.fetchPost(apiConst.getFormDataList,params)
    },
}


// WEBPACK FOOTER //
// ./src/service/api/repository/checkRoom-api.js